import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from './index.module.scss';
import TextField from '../Inputs/TextField';
import WitnessedField from './WitnessedField';
import LocationField from './LocationField';
import DateOfFallField from './DateOfFallField';

function AddFallRiskFormFields() {
  const { register } = useFormContext();

  return (
    <div className={styles.addFallform}>
      <div className="flex items-center gap-4">
        <DateOfFallField />
        <WitnessedField />
      </div>
      <LocationField />
      <TextField
        label="Comments"
        {...register('description')}
        multiline
        minRows={3}
        maxRows={3}
        placeholder="Type your comment here..."
        wrapperClassName={classNames(styles.inputWrapper, styles.largeInputWrapper)}
        inputClassName={styles.inputField}
      />
    </div>
  );
}

export default AddFallRiskFormFields;
